import React from 'react';

const Logo = () => {
  return (
    <svg
      //   width="814"
      //   height="1000"
      viewBox="0 0 814 1000"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M195 0H663.714C722.619 0 768.763 50.6597 763.28 109.309L688.48 909.309C683.674 960.707 640.536 1000 588.914 1000H195V0Z"
        fill="#EDEDED"
      />
      <path
        d="M0 0H468.714C527.619 0 573.763 50.6597 568.28 109.309L493.48 909.309C488.674 960.707 445.536 1000 393.914 1000H0V0Z"
        fill="#282828"
      />
      <rect x="78" y="137" width="381" height="62" rx="31" fill="#F5F6F7" />
      <rect x="78" y="257" width="301" height="62" rx="31" fill="#F5F6F7" />
      <rect x="78" y="377" width="237" height="62" rx="31" fill="#F5F6F7" />
      <rect x="78" y="497" width="168" height="62" rx="31" fill="#F5F6F7" />
      <rect x="78" y="617" width="61" height="62" rx="30.5" fill="#F5F6F7" />
      <rect
        x="770"
        y="746.721"
        width="335"
        height="62"
        rx="31"
        transform="rotate(-135 770 746.721)"
        fill="#1F68FA"
      />
      <rect
        x="533"
        y="895.721"
        width="335"
        height="62"
        rx="31"
        transform="rotate(-45 533 895.721)"
        fill="#1F68FA"
      />
      <rect
        x="263"
        y="671.721"
        width="529"
        height="62"
        rx="31"
        fill="#1F68FA"
      />
      <rect
        x="475.372"
        y="87.7279"
        width="50"
        height="15"
        rx="7.5"
        transform="rotate(-45 475.372 87.7279)"
        fill="#F5F6F7"
      />
      <rect
        x="510.728"
        y="97.6274"
        width="50"
        height="15"
        rx="7.5"
        transform="rotate(-135 510.728 97.6274)"
        fill="#F5F6F7"
      />
      <path
        d="M198.647 887.158C198.647 877.495 186.513 868.337 167.909 862.658C172.202 843.748 170.294 828.703 161.887 823.886C159.949 822.757 157.683 822.221 155.209 822.221V828.852C156.58 828.852 157.683 829.119 158.607 829.625C162.662 831.944 164.421 840.775 163.05 852.133C162.722 854.928 162.185 857.871 161.529 860.874C155.686 859.447 149.306 858.347 142.598 857.633C138.573 852.133 134.399 847.138 130.195 842.767C139.914 833.758 149.037 828.822 155.238 828.822V822.192C147.04 822.192 136.307 828.019 125.455 838.128C114.603 828.079 103.87 822.311 95.6711 822.311V828.941C101.842 828.941 110.995 833.847 120.714 842.797C116.541 847.167 112.367 852.133 108.401 857.633C101.664 858.347 95.2835 859.447 89.44 860.904C88.7543 857.931 88.2475 855.047 87.8897 852.281C86.4885 840.923 88.2177 832.093 92.2425 829.744C93.1369 829.209 94.2996 828.971 95.6711 828.971V822.34C93.1667 822.34 90.9009 822.876 88.9332 824.005C80.5556 828.822 78.6774 843.837 83.0003 862.688C64.4563 868.397 52.3818 877.525 52.3818 887.158C52.3818 896.821 64.5159 905.979 83.1196 911.658C78.8264 930.568 80.7345 945.613 89.1419 950.43C91.0798 951.56 93.3456 952.095 95.8499 952.095C104.049 952.095 114.782 946.267 125.634 936.158C136.486 946.208 147.219 951.976 155.417 951.976C157.922 951.976 160.188 951.441 162.155 950.311C170.533 945.494 172.411 930.479 168.088 911.628C186.572 905.949 198.647 896.792 198.647 887.158ZM159.83 867.326C158.727 871.162 157.355 875.116 155.805 879.071C154.583 876.692 153.301 874.313 151.899 871.935C150.528 869.556 149.067 867.237 147.606 864.977C151.84 865.602 155.924 866.375 159.83 867.326ZM146.175 898.992C143.85 903.006 141.465 906.812 138.99 910.35C134.548 910.736 130.046 910.944 125.514 910.944C121.013 910.944 116.511 910.736 112.098 910.379C109.624 906.841 107.209 903.065 104.883 899.081C102.618 895.186 100.56 891.231 98.6822 887.247C100.531 883.263 102.618 879.279 104.854 875.384C107.179 871.37 109.564 867.564 112.039 864.026C116.481 863.639 120.983 863.431 125.514 863.431C130.016 863.431 134.518 863.639 138.93 863.996C141.405 867.534 143.82 871.31 146.145 875.295C148.411 879.19 150.468 883.144 152.347 887.128C150.468 891.113 148.411 895.097 146.175 898.992ZM155.805 895.126C157.415 899.111 158.786 903.095 159.919 906.96C156.014 907.912 151.899 908.714 147.636 909.339C149.097 907.049 150.558 904.7 151.929 902.292C153.301 899.913 154.583 897.505 155.805 895.126ZM125.574 926.852C122.801 923.997 120.029 920.816 117.286 917.337C119.969 917.456 122.712 917.545 125.485 917.545C128.287 917.545 131.06 917.486 133.773 917.337C131.09 920.816 128.317 923.997 125.574 926.852ZM103.393 909.339C99.1592 908.714 95.0748 907.941 91.1692 906.99C92.2723 903.154 93.6437 899.2 95.194 895.245C96.4164 897.624 97.6984 900.003 99.0996 902.381C100.501 904.76 101.932 907.079 103.393 909.339ZM125.425 847.465C128.198 850.319 130.97 853.5 133.713 856.979C131.03 856.86 128.287 856.771 125.514 856.771C122.712 856.771 119.939 856.83 117.226 856.979C119.909 853.5 122.682 850.319 125.425 847.465ZM103.363 864.977C101.902 867.267 100.441 869.616 99.0698 872.024C97.6984 874.403 96.4164 876.781 95.194 879.16C93.5841 875.176 92.2127 871.191 91.0798 867.326C94.9854 866.404 99.0996 865.602 103.363 864.977ZM76.3817 902.203C65.8277 897.713 59.0004 891.826 59.0004 887.158C59.0004 882.49 65.8277 876.573 76.3817 872.113C78.9457 871.013 81.7482 870.032 84.6401 869.11C86.3394 874.938 88.5754 881.003 91.3481 887.218C88.6053 893.402 86.3991 899.438 84.7295 905.236C81.778 904.314 78.9755 903.303 76.3817 902.203ZM92.4214 944.691C88.3668 942.372 86.6078 933.541 87.9792 922.183C88.3071 919.389 88.8438 916.445 89.4997 913.442C95.3431 914.869 101.723 915.969 108.431 916.683C112.456 922.183 116.63 927.179 120.834 931.549C111.114 940.558 101.992 945.494 95.7903 945.494C94.4487 945.464 93.3158 945.197 92.4214 944.691ZM163.139 922.035C164.54 933.393 162.811 942.223 158.786 944.572C157.892 945.108 156.729 945.345 155.358 945.345C149.186 945.345 140.034 940.439 130.314 931.49C134.488 927.119 138.662 922.154 142.627 916.653C149.365 915.94 155.745 914.839 161.589 913.382C162.274 916.386 162.811 919.27 163.139 922.035ZM174.617 902.203C172.053 903.303 169.251 904.284 166.359 905.206C164.66 899.378 162.424 893.313 159.651 887.099C162.394 880.914 164.6 874.878 166.269 869.08C169.221 870.002 172.023 871.013 174.647 872.113C185.201 876.603 192.028 882.49 192.028 887.158C191.999 891.826 185.171 897.743 174.617 902.203Z"
        fill="#61DAFB"
      />
      <path
        d="M125.485 900.746C133.01 900.746 139.11 894.662 139.11 887.158C139.11 879.654 133.01 873.57 125.485 873.57C117.96 873.57 111.86 879.654 111.86 887.158C111.86 894.662 117.96 900.746 125.485 900.746Z"
        fill="#61DAFB"
      />
    </svg>
  );
};

export default Logo;
